module.exports = __webpack_public_path__ + "static/media/course_eval.9ef17b32.jpeg";